import {ICurrencyModel} from '../../../@interfaces/models/Currency/ICurrencyModel';
import {PossibleCurrencies} from '../../../@types/services/Formatter/PossibleCurrencies';
import {IPriceFormatter} from '../../../@interfaces/services/Formatter/IPriceFormatter';
import app from '../../app';


export function formatPrice(): IPriceFormatter;

export function formatPrice(
    amount: number | string,
    currency?: ICurrencyModel | PossibleCurrencies | null,
    options?: Intl.NumberFormatOptions
): string;

export function formatPrice(
    amount?: number | string,
    currency?: ICurrencyModel | PossibleCurrencies | null,
    options?: Intl.NumberFormatOptions
) {
    const service = app('price-formatter');
    if (amount == null) {
        return service;
    }

    return service.format(amount, currency, options);
}
